require('./publicBannerNews.scss');

const PropTypes = require('prop-types');

const React = require('react');
const classNames = require('classnames');

const PublicBannerNews = props => {
    // (Andres): This is just a placeholder element
    const { background } = props;
    const classes = classNames(
        'public-banner-news',
        {
            'public-banner-news--background': background
        }
    );
    let content;

    if (background) {
        content = (
            <img src={background} className="public-banner-news__background" />
        );
    } else {
        content = (
            <p className="public-banner-news__text">ESPACIO COMERCIAL</p>
        );
    }

    return (
        <article className={classes}>
            {content}
        </article>
    );
};

PublicBannerNews.propTypes = {
    background: PropTypes.string
};

module.exports = PublicBannerNews;